<template>
  <v-row class="mx-auto">
    <v-col cols="12" sm="2" md="2">
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field v-model="targetDate" label="出荷日" prepend-icon="event" readonly v-on="on"></v-text-field>
        </template>
        <v-date-picker
          v-model="targetDate"
          @input="menu1 = false"
          locale="jp-ja"
          :day-format="date => new Date(date).getDate()"
          @change="chgDate"
        ></v-date-picker>
      </v-menu>
    </v-col>

    <v-col cols="12" sm="12" md="12">
      <template v-if="isLoaded">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          item-key="id"
          class="order_table"
        >
          <template v-slot:item="{ item, isSelected }">
            <!-- <tr @click="showAlert(item)"> -->
            <tr @click="clickItem(item)" :class="tableRowClass(item, isSelected)">
              <td>
                <v-chip :color="getColor(item.status)" dark>{{ item.status | statusString }}</v-chip>
              </td>
              <td>{{ item.order_id }}</td>
              <td>{{ item.delivery_name }}</td>
              <td>{{ item.product_name }}</td>
              <td>{{ item.quantity | moneyDelemiter }}</td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </v-col>

    <v-col cols="12">
      <v-spacer></v-spacer>
    </v-col>

    <v-col cols="12" sm="12" md="12">
      <v-row>
        <v-footer color="primary" dark padless fixed>
          <v-row justify="start" no-gutters>
            <v-btn x-large class="ma-2" outlined color="dark" v-scroll-to="'#top'">
              <v-icon>fa-arrow-circle-up</v-icon>
              <span class="ma-2">TOP</span>
            </v-btn>
          </v-row>
        </v-footer>
      </v-row>
    </v-col>
    <v-col cols="12">
      <Dialog ref="dialog" />
    </v-col>
  </v-row>
</template>
<script>
import axios from 'axios'
import Dialog from '@/components/Dialog.vue'

export default {
  components: {
    Dialog
  },
  mounted: function () {
    // 注文状況一覧の取得
    this.getList()
  },
  computed: {
    isLoaded () {
      return this.loadFlag
    }
  },
  data () {
    return {
      item: null, // 出荷状態更新処理用
      targetDate: new Date().toISOString().substr(0, 10),
      saveDate: null,
      expand: false,
      headers: [
        {
          text: '出荷状況',
          value: 'status',
          sortable: true,
          align: 'left',
          width: '100'
        },
        {
          text: '注文番号',
          value: 'id',
          sortable: true,
          align: 'left',
          width: '100'
        },
        {
          text: '納入先',
          value: 'delivery_name',
          sortable: true,
          align: 'left'
        },
        {
          text: '商品名',
          value: 'product_name',
          sortable: true,
          align: 'left'
        },
        { text: '数量', value: 'quantity', sortable: true }
      ],
      menu1: false,
      selected: [],
      items: [],
      loadFlag: false
    }
  },
  methods: {
    getList () {
      //   if (this.targetDate === this.saveDate) {
      //     return
      //   }
      console.log('getUserKind = ' + this.getUserKind())
      this.$store.commit('setOverlay', { status: true })
      this.loadFlag = false
      axios
        .post('/laravel/public/order/list', {
          shipping_date: this.targetDate,
          class: this.getUserKind(),
          status_04: 1
        })
        .then(response => {
          this.items = response.data
          this.saveDate = this.targetDate
          // 1秒待つ
          setTimeout(() => {
            this.$store.commit('setOverlay', { status: false })
            this.loadFlag = true
          }, 1000)
          console.log(JSON.stringify(this.items))
        })
        .catch(error => {
          this.err = error.response.data.errors
          this.showDialog(
            'データベースアクセスエラーが発生しました',
            '出荷状況リストの取得に失敗しました。 \nシステム管理者に連絡してください。'
          )
        })
    },
    /**
     *  出荷状態更新
     */
    updateStatus (id, status) {
      let upStatus = '1'
      this.$store.commit('setOverlay', { status: true })
      if (status === '1') {
        upStatus = '3'
      } else if (status === '3') {
        upStatus = '1'
      }

      axios
        .post('/laravel/public/order/status', {
          id: id,
          status: upStatus
        })
        .then(response => {
          // 1秒待つ
          setTimeout(() => {
            this.$store.commit('setOverlay', { status: false })
            // 出荷状況の表示更新
            this.item.status = upStatus
          }, 1000)
        })
        .catch(error => {
          this.$store.commit('setOverlay', { status: false })
          this.err = error.response.data.errors
          this.showDialog(
            'データベースアクセスエラーが発生しました',
            '出荷状況の更新に失敗しました。 \nシステム管理者に連絡してください。'
          )
        })
    },

    /**
     * 出荷日変更イベント処理
     */
    chgDate () {
      console.log('出荷日が変更されました')
      // 注文状況一覧の取得
      this.getList()
    },
    /**
     * 商品クリックイベント -  状態を変更する
     */
    clickItem (item) {
      this.$store.commit('setOverlay', { status: true })
      this.item = item
      this.updateStatus(item.id, item.status)
    }
  }
}
</script>
